import React, { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import Sidebar from "../components/Sidebar";

export default function ITaxQuest() {
  const { theme } = useTheme();
  const isDark = theme === "dark";

  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const emailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());

  const handleNotify = () => {
    if (!emailValid) return;
    setSubmitted(true);
    // Wiring for the actual notify-me endpoint is TBD.
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "var(--bg-color)",
        color: "var(--color)",
        padding: 24,
        boxSizing: "border-box",
      }}
    >
      <div
        style={{
          maxWidth: "100%",
          margin: "0 auto",
          minHeight: 720,
          display: "flex",
          gap: 24,
        }}
      >
        <Sidebar activeKey="itaxquest" />

        <main
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginLeft: 96,
            width: "calc(100% - 96px)",
            padding: "40px 20px",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              width: "min(720px, 100%)",
              padding: "56px 48px",
              borderRadius: 20,
              background: isDark ? "#1e1f24" : "#fbfaf7",
              border: `1px solid ${isDark ? "#2f3038" : "#ebe9e2"}`,
              boxShadow: isDark
                ? "0 20px 50px rgba(0,0,0,0.35)"
                : "0 20px 50px rgba(28,28,45,0.06)",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              boxSizing: "border-box",
            }}
          >
            {/* Icon tile */}
            <div
              style={{
                width: 74,
                height: 74,
                borderRadius: 18,
                background: "linear-gradient(135deg, #6b57ff 0%, #8f5cff 100%)",
                display: "grid",
                placeItems: "center",
                boxShadow: "0 12px 26px rgba(107,87,255,0.35)",
                marginBottom: 24,
              }}
            >
              <svg
                width={34}
                height={34}
                viewBox="0 0 24 24"
                fill="none"
                stroke="#fff"
                strokeWidth={1.9}
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M12 3v3M12 18v3M3 12h3M18 12h3M5.6 5.6l2.1 2.1M16.3 16.3l2.1 2.1M5.6 18.4l2.1-2.1M16.3 7.7l2.1-2.1" />
                <path d="M12 8.5l1.4 2.1 2.1 1.4-2.1 1.4L12 15.5l-1.4-2.1L8.5 12l2.1-1.4L12 8.5Z" fill="#fff" stroke="none" />
              </svg>
            </div>

            {/* Coming soon pill */}
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 8,
                padding: "6px 14px",
                borderRadius: 999,
                background: isDark ? "rgba(107,87,255,0.16)" : "#eee9ff",
                color: isDark ? "#b3a3ff" : "#6046d6",
                fontSize: 11.5,
                fontWeight: 800,
                letterSpacing: "0.08em",
                marginBottom: 20,
              }}
            >
              <span
                style={{
                  width: 6,
                  height: 6,
                  borderRadius: "50%",
                  background: isDark ? "#b3a3ff" : "#6046d6",
                }}
              />
              COMING SOON
            </span>

            <h1
              style={{
                margin: "0 0 14px",
                fontSize: 30,
                lineHeight: 1.15,
                letterSpacing: "-0.02em",
                fontWeight: 800,
                color: "var(--color)",
              }}
            >
              iTaxQuest is on its way
            </h1>

            <p
              style={{
                margin: "0 0 32px",
                maxWidth: 480,
                fontSize: 15,
                lineHeight: 1.65,
                color: isDark ? "#a8adb8" : "#6b7280",
              }}
            >
              We're putting the finishing touches on iTaxQuest. It'll be worth
              the wait — we'll let you know the moment it's ready to explore.
            </p>

            {/* Notify me form */}
            {submitted ? (
              <div
                style={{
                  padding: "12px 18px",
                  borderRadius: 10,
                  background: isDark ? "rgba(52,211,153,0.14)" : "#e6f7ef",
                  color: isDark ? "#6ee7b7" : "#0f7a4d",
                  fontSize: 13.5,
                  fontWeight: 600,
                }}
              >
                Thanks! We'll email you at{" "}
                <strong style={{ fontWeight: 700 }}>{email.trim()}</strong> when
                iTaxQuest launches.
              </div>
            ) : (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleNotify();
                }}
                style={{
                  display: "flex",
                  gap: 10,
                  width: "min(460px, 100%)",
                  alignItems: "center",
                }}
              >
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  style={{
                    flex: 1,
                    height: 46,
                    padding: "0 16px",
                    borderRadius: 10,
                    border: `1px solid ${isDark ? "#3a3b45" : "#e5e2d9"}`,
                    background: isDark ? "#26272d" : "#ffffff",
                    color: "var(--color)",
                    fontSize: 14,
                    outline: "none",
                    boxShadow: isDark
                      ? "none"
                      : "0 1px 2px rgba(28,28,45,0.04)",
                  }}
                />
                <button
                  type="submit"
                  disabled={!emailValid}
                  style={{
                    height: 46,
                    padding: "0 20px",
                    borderRadius: 10,
                    border: 0,
                    background: emailValid
                      ? "linear-gradient(135deg, #6b57ff, #7d5cff)"
                      : isDark
                      ? "#3a3b45"
                      : "#c7c3f2",
                    color: "#fff",
                    fontSize: 14,
                    fontWeight: 700,
                    cursor: emailValid ? "pointer" : "not-allowed",
                    whiteSpace: "nowrap",
                    fontFamily: "inherit",
                    boxShadow: emailValid
                      ? "0 8px 18px rgba(107,87,255,0.32)"
                      : "none",
                  }}
                >
                  Notify me
                </button>
              </form>
            )}

            {!submitted && (
              <p
                style={{
                  marginTop: 14,
                  fontSize: 12.5,
                  color: isDark ? "#8b8f99" : "#8a8d94",
                }}
              >
                Just a heads-up when it launches.
              </p>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}
